@if (initialized && subscription) {
  <app-select-one-sla
    [slaProducts]="slaProducts"
    [subscription]="subscription"
    (selected)="onProductSelected($event)"
    (backEmitter)="onBack()">
  </app-select-one-sla>
}